
/*
  *default prefix "AUTOBACKUPS_BOARD"
* */
export const AT_SET_ACTION = 'AUTOBACKUPS_BOARD_SET_ACTION';
